export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-paperclip-87e1302a3544da3f60c1ba584933d343.svg";